import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  Grid,
  Checkbox,
  FormControl,
  FormControlLabel,
  Input,
  InputAdornment,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
} from "@mui/material";
import Chip from "@mui/material/Chip";

import { DateIconSvg, ListIconSvg, PersonIconSvg } from "../../images/SvgIcons";
import IconButton from "@mui/material/IconButton";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import { useDispatch, useSelector } from "react-redux";
import * as types from "../../redux/action/ActionType";
import { filter } from "underscore";
import { authHeader } from "../comman/MainFunction";
import API from "../comman/API";
import { GET_ALL_CUSTOMER_FILTER_URL } from "../../constants/ApiRoute";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function CustomerFilterModel(props) {
  const {
    open,
    handleClose,
    filterValue,
    setFilterValue,
    filterInitial,
    customerNameList,
    applyFilterFun,
    selectedCustomers,
    setSelectedCustomers,
  } = props;

  const {
    customerStatus,
    customer,
    billingDefaultDayRate,
    billingDefaultperiod,
  } = filterValue;
  const customerListSel = deCryptFun(
    useSelector((s) => s.AllCustomerListReducer)
  );
  const customerListSelectFilter = useSelector(
    (s) => s.CustomerListSelectFilter
  );
  console.log(customerListSelectFilter, "customerListSelectFilter");
  console.log(filterValue, "filterValuefilterValuefilterValuefilterValue");
  console.log(selectedCustomers, "---------------------->>>>>>");
  const dispatch = useDispatch();
  const customerList = customerListSel ? JSON.parse(customerListSel).data : [];
  const [customSel, setCustomList] = React.useState(selectedCustomers);
  const [localFilter, setLocalFilter] = React.useState(filterValue);
  const [cusList, setList] = React.useState([]);

  console.log("selected customerrrrlocalFilter", localFilter);
  console.log("selected customerrrr", customerList);
  const findDuplicateCustomerId = (array) => {
    let seen = new Set();
    let duplicates = new Set();

    array.forEach((obj) => {
      if (seen.has(obj.UserId)) {
        duplicates.add(obj.UserId);
      } else {
        seen.add(obj.UserId);
      }
    });

    return Array.from(duplicates);
  };

  const handleSearchOnChange = (event, newValue) => {
    const duplicateArray = findDuplicateCustomerId(newValue);
    if (duplicateArray && duplicateArray.length > 0) {
      const updatedNewArray = newValue.filter(
        (obj) => obj.UserId !== duplicateArray[0]
      );
      newValue = updatedNewArray;
    }

    const uniqueSelectedProjects = newValue.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.UserId === item.UserId)
    );
    setCustomList(uniqueSelectedProjects);
    // setSelectedCustomers(uniqueSelectedProjects)
    // handleSearchStateReset();

    if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
      const idsString = uniqueSelectedProjects
        .map((item) => item.UserId)
        .join(",");
    } else {
    }
  };

  const handleSearchDeleteOnChange = (value) => {
    var arr = customSel.filter((item) => item.UserId !== value);
    var uniqueSelectedProjects = arr;

    setCustomList(arr);
    console.log(arr, "agaaaaaaaaaaaaaaa");

    if (arr?.length == 0) {
      dispatch({
        type: types.CUSTOMER_SELECT_LIST_FILTER,
        payload: {
          ...filterValue,
          customer: [],
        },
      });
      setCustomList([]);
    }
    // handleSearchStateReset();

    if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
      const idsString = uniqueSelectedProjects
        .map((item) => item.UserId)
        .join(",");
    }
  };

  // const handleSearchDeleteOnChange = (value) => {

  //   console.log("TEST==>", value)

  //   var arr = selectedCustomers.filter((item) => item.UserId !== value);
  //   var uniqueSelectedProjects = arr;
  //   setSelectedCustomers(arr);

  //   handleSearchStateReset();

  //   // if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
  //   //   const idsString = uniqueSelectedProjects.map(item => item.UserId).join(',');
  //   //   getCustomerFilterList(idsString, 0);
  //   // } else {
  //   //   getCustomerFilterList("", 0);
  //   // }
  // };

  const handleSearchCheckboxOnChange = (value, isSelected) => {
    let uniqueSelectedProjects = "";
    if (isSelected) {
      var arr = customSel.filter((item) => item.UserId !== value.UserId);
      uniqueSelectedProjects = arr;
      setCustomList(arr);
    } else {
      const updatedProjects = [...customSel, value];
      setCustomList(updatedProjects);
      uniqueSelectedProjects = updatedProjects;
    }

    // handleSearchStateReset();

    if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
      uniqueSelectedProjects.map((item) => item.UserId);
      const idsString = uniqueSelectedProjects
        .map((item) => item.UserId)
        .join(",");
    }
  };

  const handleSearchStateReset = () => {
    // setApplyFilterFlag(false);
    // setPage(0);
    // setFilterValue((prevState) => ({
    //   ...prevState,
    //   customer: [],
    //   customerStatus: "",
    //   billingDefaultDayRate: "",
    //   billingDefaultperiod: "",
    // }));
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  // const [personName, setPersonName] = React.useState([]);
  // const [customerStatusCheckBox, setCustomerStatusCheckBox] = React.useState("");
  // const [BillingDefaultPeriod, setBillingDefaultPeriod] = React.useState("");
  // const [BillingDefaultDayRate, setBillingDefaultDayRate] = React.useState("");

  const resetFun = () => {
    // setPersonName([])
    // setCustomerStatusCheckBox("")
    // setBillingDefaultPeriod("")
    // setBillingDefaultDayRate("")
    // setLocalFilter(filterInitial)
    setLocalFilter((prevState) => ({
      ...prevState,
      customer: [],
      customerStatus: "",
      customerStatusActive: "",
      billingDefaultDayRate: "",
      billingDefaultperiod: "",
    }));
    setCustomList([]);
    // setFilterValue(filterInitial);
    // dispatch({
    //   type: types.CUSTOMER_SELECT_LIST_FILTER,
    //   payload: {
    //     filterInitial
    //   },
    // });
  };

  //Filter Onchange Function

  const handleChangeCustomer = (e) => {
    //setPersonName(e.target.value)

    setFilterValue({ ...filterValue, customer: e.target.value });
  };
  console.log("customers", filterValue.customer);
  const handleChangeCustomerStatus = (e) => {
    const isInactive = e.target.checked;

    // setFilterValue({
    //   ...filterValue,
    //   customerStatus: 0,
    //   customerStatusActive: '' // Deselect Active when Inactive is selected
    // });
    setLocalFilter({
      ...localFilter,
      customerStatus: 0,
      customerStatusActive: "", // Deselect Active when Inactive is selected
    });

    dispatch({
      type: types.CUSTOMER_SELECT_LIST_FILTER,
      payload: {
        ...filterValue,
        customerStatus: 0,
        customerStatusActive: "",
      },
    });
  };
  const handleChangeCustomerStatusActive = (name) => {
    console.log(name, "nameeeeeeeeeeeeee");
    // const isActive = e.target.checked;
    if (name === "Active") {
      setLocalFilter({
        ...localFilter,
        customerStatusActive: 1,
        customerStatus: "", // Deselect Inactive when Active is selected
      });
      // setFilterValue({
      //   ...filterValue,
      //   customerStatusActive: 1,
      //   customerStatus: '' // Deselect Inactive when Active is selected
      // });

      dispatch({
        type: types.CUSTOMER_SELECT_LIST_FILTER,
        payload: {
          ...filterValue,
          customerStatusActive: 1,
          customerStatus: "",
        },
      });
    } else {
      setLocalFilter({
        ...localFilter,
        customerStatusActive: "",
        customerStatus: "", // Deselect Inactive when Active is selected
      });
      // setFilterValue({
      //   ...filterValue,
      //   customerStatusActive: 1,
      //   customerStatus: '' // Deselect Inactive when Active is selected
      // });

      dispatch({
        type: types.CUSTOMER_SELECT_LIST_FILTER,
        payload: {
          ...filterValue,
          customerStatusActive: "",
          customerStatus: "",
        },
      });
    }
  };
  const handleChangeBillingDefaultPeriod = (e) => {
    //setBillingDefaultPeriod(e.target.value)
    const { name, value } = e.target;
    const intValue = value.replace(/[^\d]/g, "");
    const sanitizedValue =
      intValue === "" ? "" : Math.min(parseInt(intValue), 31).toString();
    // setFilterValue({ ...filterValue, billingDefaultperiod: sanitizedValue });
    console.log(sanitizedValue, "sanitizedValuesanitizedValue");
    setLocalFilter({ ...localFilter, billingDefaultperiod: sanitizedValue });
    dispatch({
      type: types.CUSTOMER_SELECT_LIST_FILTER,
      payload: {
        ...filterValue,
        billingDefaultperiod: sanitizedValue,
      },
    });
  };

  const handleChangeBillingDefaultDayRate = (e) => {
    const { name, value } = e.target;
    const sanitizedValue = value.replace(/[^\d.]/g, "");
    if ((sanitizedValue.match(/\./g) || []).length > 1) {
      return;
    }

    if (/^0[0-9]+/.test(sanitizedValue)) {
      const correctedValue = sanitizedValue.replace(/^0+/, "");
      // setFilterValue({ ...filterValue, billingDefaultDayRate: correctedValue });
      setLocalFilter({ ...localFilter, billingDefaultDayRate: correctedValue });
      dispatch({
        type: types.CUSTOMER_SELECT_LIST_FILTER,
        payload: {
          ...filterValue,
          billingDefaultDayRate: correctedValue,
        },
      });
      return;
    }

    const decimalParts = sanitizedValue.split(".");
    if (decimalParts[1] && decimalParts[1].length > 2) {
      return;
    }

    // setFilterValue({ ...filterValue, billingDefaultDayRate: sanitizedValue });
    setLocalFilter({ ...localFilter, billingDefaultDayRate: sanitizedValue });
    dispatch({
      type: types.CUSTOMER_SELECT_LIST_FILTER,
      payload: {
        ...filterValue,
        billingDefaultDayRate: sanitizedValue,
      },
    });
  };

  const handleClearCustomer = (e) => {
    //setPersonName(e.target.value)
    // setFilterValue({ ...filterValue, customer: [] });
  };
  const applyFilterFuncall = () => {
    console.log(localFilter, "localFilterlocalFilter");
    setFilterValue(localFilter);

    dispatch({
      type: types.CUSTOMER_SELECT_LIST_FILTER,
      payload: localFilter,
    });

    console.log("select cust", selectedCustomers, customSel);
    const combinedArray = selectedCustomers.concat(customSel);

    const uniqueArray =
      customSel?.length > 0
        ? combinedArray.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.UserId === item.UserId)
          )
        : [];

    setSelectedCustomers(customSel?.length > 0 ? customSel : []);

    console.log(customSel, "customSelcustomSelcustomSel");
    console.log("unique", uniqueArray);

    applyFilterFun(uniqueArray, localFilter);
  };

  const getSelectedCustomerList = async () => {
    var filterValue = null;
    console.log(
      customerListSelectFilter.customerStatus,
      "(customerListSelectFilter.customerStatus",
      customerListSelectFilter.customerStatusActive
    );
    if (customerListSelectFilter.customerStatus === 0) {
      filterValue = 0;
    }
    if (
      customerListSelectFilter.customerStatus == "" &&
      customerListSelectFilter.customerStatusActive == 1
    ) {
      filterValue = 1;
    }
    console.log(filterValue, "filterrrrrrrrrrrrrrrr");
    let data = {
      count: 1000,
      offset: 0,
      active: filterValue,
    };
    const config = {
      method: "GET",
      url: GET_ALL_CUSTOMER_FILTER_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        setList(parsedResponse.data);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        //       showToast(v.message, "error");
      }
    }
  };
  React.useEffect(() => {
    getSelectedCustomerList();
  }, [localFilter.customerStatus, localFilter.customerStatusActive]);

  return (
    <>
      <Dialog
        className="user-filter-popup cst-filter"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "25px 34px" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Typography className="model-title">Filter Properties</Typography>
          <Button
            className="edit-btn"
            variant="outlined"
            startIcon={<span class="material-symbols-outlined">history</span>}
            onClick={resetFun}
          >
            Reset Filter
          </Button>
        </Stack>
        <Box sx={{ p: "0px 34px 0px 34px" }}>
          <p style={{ marginBottom: "-4px" }} className="label">
            Customer Status:
          </p>
          <Stack
            sx={{ ml: "-3px" }}
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            spacing={2}
          >
            <FormControlLabel
              className="checkbox"
              control={
                <Checkbox
                  name="customerStatusActive"
                  id="customerStatusActive"
                  onChange={() => handleChangeCustomerStatusActive("All")}
                  checked={
                    localFilter.customerStatusActive === "" &&
                    localFilter.customerStatus === ""
                      ? true
                      : false
                  }
                  // disabled={editFlag}
                  sx={{ color: "gray" }}
                />
              }
              label="All"
            />
            <FormControlLabel
              className="checkbox"
              control={
                <Checkbox
                  name="customerStatusActive"
                  id="customerStatusActive"
                  onChange={() => handleChangeCustomerStatusActive("Active")}
                  checked={
                    localFilter.customerStatusActive === 1 ? true : false
                  }
                  // disabled={editFlag}
                  sx={{ color: "gray" }}
                />
              }
              label="Active"
            />

            <FormControlLabel
              className="checkbox"
              control={
                <Checkbox
                  name="CustomerStatus"
                  id="CustomerStatus"
                  // disabled={editFlag}
                  onChange={handleChangeCustomerStatus}
                  checked={localFilter.customerStatus === 0 ? true : false}
                  sx={{ color: "gray" }}
                />
              }
              label="Inactive"
            />
          </Stack>
          <FormControl
            className="search-box cs-filter-search"
            sx={{
              width: 350,
            }}
          >
            {/* <InputLabel id="demo-multiple-chip-label">Chip</InputLabel> */}

            <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              options={cusList}
              disableCloseOnSelect
              limitTags={1}
              getOptionLabel={(option) => option.Name}
              filterOptions={(options, { inputValue }) => {
                if (inputValue.trim() === "") {
                  return options;
                }
                return options.filter((option) =>
                  option.Name.toLowerCase().includes(inputValue.toLowerCase())
                );
              }}
              onChange={handleSearchOnChange}
              value={customSel}
              renderTags={() => null}
              renderOption={(props, option, { selected }) => {
                const isSelected = customSel.some(
                  (project) => project.UserId === option.UserId
                );

                return (
                  <li {...props} key={option.UserId}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={isSelected}
                      onChange={() =>
                        handleSearchCheckboxOnChange(option, isSelected)
                      }
                    />
                    <span className="select-option-text">{option.Name}</span>
                  </li>
                );
              }}
              style={{ width: 350 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Search Customers"
                />
              )}
            />
          </FormControl>

          <Stack
            direction="row"
            spacing={1}
            flexWrap="wrap"
            style={{ marginBottom: "0px" }}
          >
            {customSel.map((option) => (
              <Chip
                label={option.Name}
                onDelete={() => handleSearchDeleteOnChange(option.UserId)}
                style={{ margin: 5 }}
              />
            ))}
          </Stack>
          <Stack
            sx={{ mt: "30px" }}
            direction="row"
            alignItems="center"
            spacing={2}
          >
            <FormControl sx={{ width: "100%" }} variant="standard">
              <p className="label">Billing Default Day Rate:</p>
              <Input
                className="dollar-field"
                name="billingDefaultDayRate"
                id="billingDefaultDayRate"
                value={localFilter.billingDefaultDayRate}
                onChange={handleChangeBillingDefaultDayRate}
                // disabled={editFlag}
                placeholder="Enter Billing Day Rate"
                startAdornment={
                  <InputAdornment position="start">
                    <span className="dollar-icon">$</span>
                  </InputAdornment>
                }
                // error={errors.email && touched.email}
                // helperText={errors.email && touched.email ? errors.email : ""}
              />
              {/* <FormHelperText error={true}>
                {errors.email && touched.email ? errors.email : ""}
              </FormHelperText> */}
            </FormControl>
            <FormControl sx={{ width: "100%" }} variant="standard">
              <p className="label">Billing Default Period (in days):</p>
              <Input
                name="billingDefaultPeriod"
                id="billingDefaultPeriod"
                value={localFilter.billingDefaultperiod}
                onChange={handleChangeBillingDefaultPeriod}
                // disabled={editFlag}
                placeholder="Enter Billable Period"
              />
            </FormControl>
          </Stack>
        </Box>
        <DialogActions
          sx={{
            justifyContent: "flex-start",
            p: "26px 34px",
            mt: "15px",
            pt: "0px",
          }}
        >
          <Button className="filter-btn" onClick={applyFilterFuncall}>
            Apply Filter
          </Button>
          <Button
            className="cancel-btn"
            onClick={() => {
              setLocalFilter(filterValue);
              handleClose();
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
